import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

export const ADMIN_ONLY_TOOLTIP =
  'This submenu is only available to Borrah admins in an active impersonation session.';

export function AdminOnlyBadge({ className }: { className?: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          aria-label="Admin only"
          className={cn(
            'inline-flex h-5 shrink-0 self-center items-center rounded bg-red-600 px-1.5 text-[10px] font-bold leading-none text-white',
            className
          )}
          title={ADMIN_ONLY_TOOLTIP}
        >
          AO
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-72 text-center" side="top">
        {ADMIN_ONLY_TOOLTIP}
      </TooltipContent>
    </Tooltip>
  );
}
